import React, { useEffect } from 'react';

import Chart from './chart';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';
import useWindowDimensions from 'Components/hooks/useWindowDimensions';

const VaccinationChartContainer = (props) => {
  const { vaccinations, country } = props;

  const chart = new Chart();
  const chartRef = React.createRef();
  const { width } = useWindowDimensions();

  const resize = debounce(() => {
    chart.draw();
  }, 250);

  // Draw chart
  useEffect(() => {
    const data = { vaccinations, country };
    chart
      .selection(chartRef.current)
      .props({
        height: width > 600 ? 225 : 125,
        margin:
        { right: width > 600 ? 50 : 40 },
      })
      .data(data)
      .draw();
  }, [vaccinations, country, chartRef]);

  // Resize chart
  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={classnames(component)}>
      <div ref={chartRef} />
    </div>
  );
};

export default VaccinationChartContainer;
